<template>
    <v-layout>
      <div v-if="needInit && getLanguageIcons && user">{{initData()}}</div>
      
        <v-flex xs12 v-if="myContent!=null"> 
            <v-card class="shadow-none background-transparent">
              <v-card-text>
                 <v-layout class="vertically-horizontally-centered">
                    <v-flex xs6 v-if="showIndex > -1">
                        <v-card class="shadow-none background-transparent">                          
                            <v-card-text>
                                <v-layout>
                                        <!-- <v-flex xs1>
                                            <img class="lang-icon btn-close" style= "left: 4px;" :src="getLanguageIcons[showIndex].url" />
                                        </v-flex> -->


                                    <!-- languages -->
                                    <v-flex xs10 class="position-relative">       
                                        <div v-if="myContent.languages[showIndex].permissions" class="universal-row-item__group-btn-chip">
                                                <div class="lang-side">
                                                    <img class="lang-side__img" :src="getLanguageIcons[showIndex].url" />
                                                </div>
                                                
                                                <v-icon small @click="prepareEditShowed()">edit</v-icon>
                                                <v-icon small @click ="clearTranslation(showIndex)">delete</v-icon>                                
                                                <v-icon v-if="myContent.languages[showIndex].visible == 0" small @click="changeVisibility(showIndex)">visibility_off</v-icon>                                       
                                                <v-icon v-else small @click="changeVisibility(showIndex)">visibility</v-icon>                                       
                                        </div>

                                        <div @click="openLesson()" class="card-border-style pa-2 universal-row-item__group-btn-chip-subbox">
                                            <h3 v-if= "myContent.languages[showIndex].name.length > 0">{{myContent.languages[showIndex].name}}</h3>
                                            <h4 v-else style="color:orange">-- not translated  --</h4>                                       
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>

                    <v-flex xs3 class="language__translator-group vertically-horizontally-centered" data-title="translated (click to show)">
                        <span v-for="(language,index) in myContent.languages" :key=index class="translator-group__item">
                            <img v-if="language.translated" class="translator-group__lang-icon cursor-pointer" :src="getLanguageIcons[language.lang_id-1].url"
                            :title='getLanguageIcons[language.lang_id-1].title'  @click ="showIndex = index"
                            />
                        </span>    
                    </v-flex>
                    <v-flex xs3 class="language__translator-group vertically-horizontally-centered" data-title="not translated (click to edit)">
                        <span v-for="(language,index) in myContent.languages" :key=index class="translator-group__item">
                            <img v-if="!language.translated" class="translator-group__lang-icon cursor-pointer" :src="getLanguageIcons[language.lang_id-1].url"
                            :title='getLanguageIcons[language.lang_id-1].title' @click ="prepareEdit(index)"
                            :style="getCursorPermission(index)"
                            />
                        </span>  
                    </v-flex> 
                 </v-layout>

                 <v-flex xs12 v-if="editIndex > -1 && myContent.languages[editIndex].permissions">
                        <v-card class="shadow-none active-border-style border-radius-md px-2">
                            <v-card-text>
                                <v-icon class="btn-close" @click="editIndex = -1" dense>close</v-icon>  
                                <v-layout row wrap>
                                    <v-flex xs1>
                                        <img class="lang-icon" :src="getLanguageIcons[editIndex].url">
                                    </v-flex>
                                    <v-flex xs1>

                                    </v-flex>
                                    <v-flex xs2>
                                    </v-flex>
                                    <v-flex xs7>
                                        <v-text-field                                
                                            label="Type the name"
                                            v-model="tmpName"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs1 align-self-end class="d-flex align-end flex-column">
                                         <v-icon @click="saveData()">done</v-icon>
                                    </v-flex>                                
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>
            </v-card-text>   
          </v-card>
      </v-flex>
    
  </v-layout>
</template>

<script>
import axios from '../../../axios-auth.js'
import {mapGetters} from 'vuex'

  export default {
    data() {
      return {
        needInit : false,
        myContent : null,
        showIndex : -1,
        editIndex: -1,
        // editObject: -1, // 0 - type, 1 - icon, 2 - text
        channame: '',
        systemPermissions : null,
        tmpName: ''
      }
    },
    props: { 
        my_element: Object, 
        permissions : Array,
        lang_index : String
    },    
    watch: { 
        lang_index: function(newVal, oldVal) { // watch it
          if(oldVal != newVal)
            this.showIndex = newVal
        },
    },
    computed: 
        mapGetters([
                        'getLanguageIcons',
                        'user'
                    ])
    ,
    mounted() {
        this.needInit = true
    },
   methods: {
    initData() {
        this.needInit = false  
        this.$store.commit('setFeedback', null)
        this.systemPermissions = this.$store.getters.getSystemPermissions
        this.prepareContent(this.my_element)
        this.showIndex = parseInt(this.lang_index)
   
        if (this.my_element.edit != null) 
            this.prepareEdit(this.showIndex)
    },
    prepareContent(_element) {
        this.myContent = {
            id : this.my_element.id,
            order: this.my_element.order,
            languages : []      
        }
        var j = 0
        for(let i = 0; i < this.getLanguageIcons.length; i++) {
            if (j >= _element.translations.length || _element.translations[j].lang_id != this.getLanguageIcons[i].id) {
                this.myContent.languages.push( {
                    lang_id: this.getLanguageIcons[i].id,
                    name: '',
                    visible: 1,
                    translated: false,
                    permissions: this.getPermissions(this.getLanguageIcons[i].id, this.myContent.id)
                  }                  
                )                
            } else { // ==
                this.myContent.languages.push( {
                    lang_id: this.getLanguageIcons[i].id,
                    name: _element.translations[j].name,
                    visible: _element.translations[j].visible,
                    translated: _element.translations[j].name.length > 0 ? true : false,
                    permissions: this.getPermissions(this.getLanguageIcons[i].id, this.myContent.id)
                  }
                )
                j = j + 1
            }
        }
    },
    getPermissions(_lang_id, _chapter_id) {
        if (this.permissions.length < 1) return false        
        for(let i = 0; i< this.permissions.length; i++) {
            if (this.permissions[i].role_code > 999) 
              return true
            if (this.permissions[i].role_code == this.systemPermissions.course_content_creator)
              return true
            if ((this.permissions[i].role_code == this.systemPermissions.course_content_translator)
               && (_lang_id == this.permissions[i].language_id))
              return true
            if ((this.permissions[i].role_code == this.systemPermissions.chapter_content_creator)
                   && (_chapter_id == this.permissions[i].sub_obj_id))
              return true
            if ((this.permissions[i].role_code == this.systemPermissions.chapter_content_translator)
                   && (_lang_id == this.permissions[i].language_id)
                   && (_chapter_id == this.permissions[i].sub_obj_id))
              return true
        }
        return false
    },
    getCursorPermission(_index) {
        if (this.myContent.languages[_index].permissions)
           return "cursor:pointer;"
        return "cursor:not-allowed;"
    },
    prepareEditShowed() {              
        this.prepareEdit(this.showIndex)
    },
    prepareEdit(_index) {    
        this.editIndex = _index
        this.tmpName = this.myContent.languages[this.editIndex].name
    },
    // saving via axios
    changeVisibility(_index) {
        this.myContent.languages[_index].visible = 1-this.myContent.languages[_index].visible
        this.finalSave(_index, 1)
    },
    clearTranslation(_index) { 
        if (!this.myContent.languages[_index].translated) return
        this.myContent.languages[_index].name = ''
        this.myContent.languages[_index].translated = false
        this.finalSave(_index, 1)
    },
    saveData() {
        const _index = this.editIndex
        this.myContent.languages[_index].name = this.tmpName
        if (this.tmpName.length > 0)
            this.myContent.languages[_index].translated = true
        else 
            this.myContent.languages[_index].translated = false
        this.editIndex = -1
        this.finalSave(_index, 1) // only translation
    },
    finalSave(_index, _only_translation) {
        const _data = {
            lesson_id: this.myContent.id,
            lesson_order: this.myContent.order,        
            chapter_id: this.$route.params.id, 
            visibility: this.myContent.languages[_index].visible, 
            lesson_name: this.myContent.languages[_index].name,
            lang_id: this.myContent.languages[_index].lang_id,
            only_translation: _only_translation
        }
        axios.post('/edit-lesson', _data, this.$store.getters.getAxiosConfig)
          .then(res => {
            if (res.data.message != 'OK') {
                this.$store.commit('setFeedback', res.data.message)
            }
          })
          .catch(error => {
              this.$store.commit('setFeedback', error)
          })
    },
    openLesson() {
         this.$router.push({name:'task_list', params: {id: this.my_element.id}})
    }
   }
  }
  </script>